import { apiClient } from "../apiClientService";

export const fetchUserProfileService = async () => {
  return await apiClient("GET", "/api/users/profile");
};

export const updateUserProfileService = async (formData) => {
  return await apiClient("PUT", "/api/users/profile", formData, {
    isJson: false,
  });
};
